import axios from 'axios';
import store from '@/store/index.js'
import router from '@/router/index.js'
import ElementUI from "element-ui";
import {
  info
} from '@/assets/js/common.js';
import bus from '@/components/common/bus.js';
import moment from 'moment-timezone';
import { v4 as uuid } from "uuid";
import { Trace } from '@utils/trace';
import i18n from '@/i18n/i18n';

const { VUE_APP_host } = process.env

// let host = window["host"] || 'https://iot.opple.com'; //"http://139.219.226.99:8085"; //接口主域名
export let host = VUE_APP_host || window.host || window.location.origin; //"http://139.219.226.99:8085"; //接口主域名

// var proxy = window["proxy"] || '';
export var proxy = process.env.VUE_APP_PROXY || ''


const JUMP_LOGIN_CONF = [{
  code: 12004,
  msg: i18n.t('login.tokenError'),  // 'Token错误，或者登陆超时！',
}, {
  code: 12005,
  msg: i18n.t('login.accountDisabled'), // '帐号被禁用！',
}, {
  code: 12006,
  msg: i18n.t('login.userNotActivated'), // '用户未激活',
}, {
  code: 12007,
  msg: i18n.t('login.userFrozen'),
}, {
  code: 12008,
  msg: i18n.t('login.tokenError'), // 'Token过期，或者登陆超时！'
}]

const JUMP_LOGIN_CODES = JUMP_LOGIN_CONF.map(item => item.code);
// const options = { timeZoneName: 'long' };
// const formatter = new Intl.DateTimeFormat([], options);
// const parts = formatter.formatToParts(new Date());

// let timeZone = '';
// for (const part of parts) {
//   if (part.type === 'timeZoneName') {
//     timeZone = part.value;
//     break;
//   }
// }

// console.log('timeZonetimeZonetimeZonetimeZone', moment.tz.);


export function createRequestHeader(headertype, isNoprojectcode, extendHeader = {}) {
  let token = '';
  let gps = '';
  let qrcode = '';
  let contentType = 'application/json; charset=utf-8';

  if (headertype === 1) {
    token = store.state.token;
    gps = store.state.GPS;
    qrcode = store.state.qrcode;
  }

  if (headertype === 3) {
    token = store.state.token;
    contentType = "multipart/form-data;";
    
  }

  const timeZone = moment.tz.guess();
  const timeZoneOffset = moment.tz(timeZone).utcOffset();

  const header = {
    'Content-Type': contentType,
    'Token': token,
    'Lang': store.state.lang,
    'ProjectCode': store.state.projectcode,
    'uuid': isNoprojectcode ? '' : store.state.systemjsuuid,
    'Position': gps,
    'QRCode': qrcode,
    'headertype': headertype,
    'Accept': contentType,
    'App-TimeZon': timeZone,
    "App-TimeZone-Offset": `${timeZoneOffset < 0 ? timeZoneOffset : '+' + timeZoneOffset}`, //`${data.getTimezoneOffset()}`,
    "App-Version": store.state.edition,
    "ClientId": store.state.clientId,
    "client-up-time": `${new Date().getTime()}`,
    "tid": uuid(),
    ...extendHeader,
  };

  return header;
}

/**
 * 核对 版本
 */
export function editionCheck() {
  var editionLocal = getLocalStoragItem("edition");
  var editionCur = store.state.edition;
  setLocalStoragItem("edition", editionCur);
  if (editionLocal != editionCur) {
    editionLocal = null;
    editionCur = null;
    router.go(0);
  }
}

//切换国家接口域名切换
export function switchIp() {
  try {
    if(store.state.ipConfigOpen){
      // if(store.state.chooseIsEurope === false){
      //   host = `https://${store.state.IP2}.opple.com`
      // }else{
      //   host = `https://${store.state.IP1}.opple.com`
      // }
      console.log('.....switchIp.', window.defaultDomaims)
      console.log('.....host.', host)
      // host = window.defaultDomaims || host
    }
  } catch (error) {
  }
}

//debug 日志
export function tuiLog(param, type) {
  let systemLogValue = null;
  if (type == "socket") {
    systemLogValue = document.getElementById("systemLogSocket");
  } else {
    systemLogValue = document.getElementById("systemLogValue");
  }
  if (systemLogValue != null) {
    if (systemLogValue.value.length > 100000) { //预留1百万LOG数据
      systemLogValue.value = "";
    }
    let time = new Date();
    time = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate() + " " + time.getHours() + ':' + time.getMinutes() + ':' + time.getSeconds();
    systemLogValue.value = time + " [-] " + param + "\r\n⇝\r\n" + systemLogValue.value;
    time = null;
  }
  systemLogValue = null;
}
export function downDataNew(methods, params, that, title, urlParams) {
  let url = host + proxy + methods;
  var elemIF = document.getElementById("opple_vue_loger_download");
  if (elemIF == null) {
    elemIF = document.createElement('iframe');
    elemIF.id = "opple_vue_loger_download";
    elemIF.style.display = 'none';
    document.body.appendChild(elemIF);
  }
  elemIF.src = url + urlParams + '&Lang=' + store.state.lang;
  
  info(that, title);
}

export function downData(methods, params) {
  let url = host + proxy + methods;
  window.open(url + "?projectCode=" + params.projectCode + "&gpNo=" + params.gpNo + "&page=" + params.page + "&pageSize=655350&deviceName=" + (params.deviceName || '') + "&eventID=" + (params.eventID || '') + "&content=" + (params.content || '') + (params.logLevel != null ? "&logLevel=" + params.logLevel : "&logLevel=0&logLevel=1&logLevel=2") + "&vDeviceId=" + (params.vDeviceId || '') + "&deviceMac=" + (params.deviceMac || '') + "&startDate=" + (params.startDate || '') + "&endDate=" + (params.endDate || ''));
}
  
/**
 * 检测是否需要跳转
 * @param {*} StatusCode 
 * @returns 
 */
function checkNeedJumpLogin(StatusCode, nojump) {
  // 不需要验证
  if (nojump) return false;

  if (JUMP_LOGIN_CODES.includes(StatusCode)) {
  // 弹窗发逻辑
    const errorMsg = JUMP_LOGIN_CONF.find(item => item.code === StatusCode).msg;

    // 是否在星辰
    const isInXingCheng = store.state.isInXingCheng || false;
   
    // 不需要弹窗
    if (isInXingCheng && !window.INVISIBLE) {
      // 假设父页面的域名是 'example.com'（根据实际情况修改）
      let url = process.env.VUE_APP_XC_IFRAME_URL
      if(url){
         const _url = new URL(url)
         url = _url.origin
      }
      url = window.fatherOrigin ||  url || 'http://localhost:9999'
      //  window.parent && window.parent.postMessage({ type: 'LINK_LOGIN' }, url);
      
      return false;
    }
    if(store.state.routermsg === '/login' && StatusCode =='12004'){
      console.log('.....不需要弹窗')
    }else{
      store.commit('setGlobalModalData', {msg: errorMsg,isShow: true});
    }
   
    return true;
  }

  return false;
}


export function postData(methods, params = {}, headertype, fn, cparameter, extendHeader, options = {}) {
  const startTime = Date.now() // 请求开始时间
  editionCheck();
  tuiLog("LogEvent [POST-Parameters]→" + JSON.stringify({
    "方法名称": methods,
    "参数对象": params,
    "是否toekn": headertype,
    "cparameter": cparameter
  }));
  cparameter = cparameter || {};

  switchIp()

  let url = host + proxy + (store.state.apibase || '') + methods;

  return new Promise((resolve, reject) => {
    const headers = createRequestHeader(headertype, !!params["noprojectcode"],extendHeader || {})
    axios.post(url, params, {
      timeout: 60000,
      // headers: createRequestHeader(headertype, !!params["noprojectcode"]),
      headers,
      onUploadProgress: options?.onUploadProgress
    }).then((res, param) => {
       // trace
       try {
        Trace({
          method: "POST",
          host,
          path: url,
          sendTs: startTime,
          reqHeaders: headers,
          resultCode: res.data.StatusCode,
        })
       } catch (error) { }


      const StatusCode = Number(res.data.StatusCode);
       
      const isNeedJump = checkNeedJumpLogin(StatusCode, params.nojump);

      if (isNeedJump) return;
      //token失效手动跳转login
      // if(res.data.StatusCode === 12004){
      //   router.push({
      //     name: 'login'
      //   });
      // }
      bus.$emit('oppleEvent', {
        res: res,
        param: params
      });
      tuiLog("LogEvent [POST-Response]→" + (params["url"] || '') + '→' + JSON.stringify(res));
      // if(res.config.headers._host != null){return typeof fn == "function" && fn(res.data,params,cparameter);}
      if (res.data.StatusCode != null) {
        // if (res.data.StatusCode != store.state.tokenMiss) {
        typeof fn == "function" && fn(res.data, params, cparameter);

        resolve(res.data);
      } 
      
      // else if (params["nojump"] != true) {
      //     router.push({
      //       name: store.state.routerHome
      //     });
      //   }
    }).catch(err => {
      bus.$emit('oppleEvent', {
        res: err.response,
        param: params
      });
      tuiLog("LogEvent [POST-Response]→" + (params["url"] || '') + '→' + JSON.stringify(err));
      if (err.request) {
        console.log('超时');
        ElementUI.Message({
          message: err,
          type: 'warning'
        });
      } else {
        console.log('error:' + err);
      }

      reject(err);
    });

    // url = null;
    // token = null;
    // contenttype = null;
  })
}
//methods方法名称 params参数对象 headertype(1需要token 2不需要toekn) fn返回数据  （get提交） cparameter自定义参数可不传  
export function getData(methods, params = {}, headertype, fn, cparameter, extendHeader) {
  const startTime = Date.now() // 请求开始时间
  editionCheck();
  tuiLog("LogEvent [GET-Parameters]→" + JSON.stringify({
    "方法名称": methods,
    "参数对象": params,
    "是否toekn": headertype,
    "cparameter": cparameter
  }));
  cparameter = cparameter || {};

switchIp()

  let url
  try {
    if (cparameter.localApi) {
      url = host + cparameter.localApi + (store.state.apibase || '') + methods;
    } else {
      url = host + proxy + (store.state.apibase || '') + methods;
    }
  } catch (err) {

  }

  return new Promise((resolve, reject) => {
    const headers = createRequestHeader(headertype, !!params["noprojectcode"], extendHeader || {})
    
    axios.get(url, {
      params,
      timeout: 60000,
      headers,
      validateStatus: function (status) {
        return status < 500; // 状态码在大于或等于500时才会 reject
      }
    }).then((res, param) => {
      // trace
      try {
        Trace({
          method: "GET",
          host,
          path: url,
          sendTs: startTime,
          reqHeaders: headers,
          resultCode: res.data.StatusCode,
        })
      } catch (error) { }

      // //token失效手动跳转login
      // if(res.data.StatusCode === 12004){
      //   router.push({
      //     name: 'login'
      //   });
      // }
  
      const StatusCode = Number(res.data.StatusCode);
      const isNeedJump = checkNeedJumpLogin(StatusCode, params.nojump);

      if (isNeedJump) return;

      bus.$emit('oppleEvent', {
        res: res,
        param: params
      });
      tuiLog("LogEvent [GET-Response]→" + (params["url"] || '') + '→' + JSON.stringify(res));
      // if(res.config.headers._host != null){return typeof fn == "function" && fn(res.data,params,cparameter);}
      if (res.data.StatusCode != null) {
        // if (res.data.StatusCode != store.state.tokenMiss) {
        typeof fn == "function" && fn(res.data, params, cparameter);

        resolve(res.data);
      } 
      
      // else if (params["nojump"] != true) {
      //     router.push({
      //       name: store.state.routerHome
      //     });
      //   }
    }).catch(err => {
      bus.$emit('oppleEvent', {
        res: err.response,
        param: params
      });
      tuiLog("LogEvent [GET-Response]→" + (params["url"] || '') + '→' + JSON.stringify(err));
      console.log(err);
      if (err.request) {
        // console.log(err);
        ElementUI.Message({
          message: err,
          type: 'warning'
        });
      } else {
        console.log('error:' + err);
      }
      reject(err);
    });
  });
}

export function delData(methods, params, headertype, fn, cparameter) {
  editionCheck();
  tuiLog("LogEvent [POST-Parameters]→" + JSON.stringify({
    "方法名称": methods,
    "参数对象": params,
    "是否toekn": headertype,
    "cparameter": cparameter
  }));
  cparameter = cparameter || {};
  let url = host + proxy + (store.state.apibase || '') + methods;
  // if(_host != null){url = _host;}
  let token = '';
  let gps = '';
  let qrcode = '';
  let contenttype = 'application/json;';
  if (headertype == 1) {
    token = store.state.token;

    // store.state.GPS = encryption(JSON.stringify({
    //   Type: 5,
    //   Latitude: 31.173945,
    //   Longitude: 121.372425
    // }));

    gps = store.state.GPS;
    qrcode = store.state.qrcode;

    var ddd = decryption(gps);
    var dddd = JSON.parse(ddd);
    ddd = null;
    dddd = null;

  }
  if (headertype == 3) {
    token = store.state.token;
    contenttype = "multipart/form-data;";
  }
  var projectcode = store.state.projectcode;
  var systemjsuuid = store.state.systemjsuuid;
  if (params["noprojectcode"] == true) {
    projectcode = '';
  }
  axios.delete(url, params, {
    timeout: 60000,
    headers: {
      // "_host":_host,
      'Content-Type': contenttype + " charset=utf-8",
      'Token': token,
      'Lang': store.state.lang,
      'ProjectCode': projectcode,
      'uuid': systemjsuuid,
      'Position': gps,
      'QRCode': qrcode,
      'headertype': headertype,
    }
  }).then((res, param) => {
    bus.$emit('oppleEvent', {
      res: res,
      param: params
    });
    tuiLog("LogEvent [POST-Response]→" + (params["url"] || '') + '→' + JSON.stringify(res));
    // if(res.config.headers._host != null){return typeof fn == "function" && fn(res.data,params,cparameter);}
    if (res.data.StatusCode != null && store.state.tokenMiss.indexOf(res.data.StatusCode) < 0) {
      // if (res.data.StatusCode != store.state.tokenMiss) {
      return typeof fn == "function" && fn(res.data, params, cparameter);
    } else if (params["nojump"] != true) {
        router.push({
          name: store.state.routerHome
        });
      }
  }).catch(err => {
    bus.$emit('oppleEvent', {
      res: err.response,
      param: params
    });
    tuiLog("LogEvent [POST-Response]→" + (params["url"] || '') + '→' + JSON.stringify(err));
    if (err.request) {
      console.log('超时');
      ElementUI.Message({
        message: err,
        type: 'warning'
      });
    } else {
      console.log('error:' + err);
    }
  });
  url = null;
  token = null;
  contenttype = null;
}

export function HttpGet(url, params, fn) {
  axios.get(url, {
    params,
  }).then((res, param) => {
    console.log(res.data);
    if (res.data.status == 'OK') {
      fn(res.data);
    }
  }).catch(err => {
    fn(err);
  });
}